export const config: typeof window.__CONFIG__ = {
  SERVICE_NAME: window.__CONFIG__.SERVICE_NAME,
  ENV_NAME: window.__CONFIG__.ENV_NAME,
  API_BASE_URL: window.__CONFIG__.API_BASE_URL,
  VGS_VAULT_ID: window.__CONFIG__.VGS_VAULT_ID,
  VGS_ENV: window.__CONFIG__.VGS_ENV,
  VGS_VERSION: window.__CONFIG__.VGS_VERSION,
  VGS_ROUTE_ID: window.__CONFIG__.VGS_ROUTE_ID,
  THEME: window.__CONFIG__.THEME,
  MAPBOX_TOKEN: window.__CONFIG__.MAPBOX_TOKEN,
  MAPBOX_STYLE_URL: window.__CONFIG__.MAPBOX_STYLE_URL,
};

/** Official style used until a Mapbox Studio style is configured. */
export const DEFAULT_MAPBOX_STYLE_URL = 'mapbox://styles/mapbox/streets-v12';

/** Empty / placeholder tokens must not reach Mapbox — the locator shows a
 *  setup notice instead of a broken canvas. */
export const mapboxToken = (config.MAPBOX_TOKEN ?? '').trim().startsWith('pk.')
  ? (config.MAPBOX_TOKEN as string).trim()
  : '';

export const mapboxStyleUrl =
  (config.MAPBOX_STYLE_URL ?? '').trim() || DEFAULT_MAPBOX_STYLE_URL;
